import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_foldable_content()
})

function dhsv_vc_foldable_content() {
  const $foldableContent = $('.dhsv_vc_foldable_content')
  const linesNumber = $foldableContent.data('lines_number')
    ? $foldableContent.data('lines_number')
    : 3

  $foldableContent.each(function () {
    const $foldableContentSpoiler = $('.js-foldable-spoiler', $foldableContent)
    const autoHeight = $(
      '.foldable-content__wrapper',
      $foldableContent
    ).height() // get original height
    const defaultHeight =
      $('.foldable-content__heading', $foldableContent).height() +
      parseInt($('p', $foldableContent).css('line-height')) * linesNumber // get default height

    $foldableContentSpoiler.height(defaultHeight) // set default height

    function animateHeight($foldableContentSpoiler, height) {
      $foldableContentSpoiler.animate(
        {
          height,
        },
        500
      )
      toggleState = !toggleState
    }

    let toggleState = false

    $('.js-foldable-spoiler-toggler', $foldableContent).on(
      'click',
      function () {
        if (!toggleState) {
          animateHeight($foldableContentSpoiler, autoHeight, toggleState)
        } else {
          animateHeight($foldableContentSpoiler, defaultHeight, toggleState)
        }
        $('.foldable-content__spoiler', $foldableContent).toggleClass('opened')
        $(this).toggleClass('active')
      }
    )
  })
}
